import { render, staticRenderFns } from "./ClassesAdd.vue?vue&type=template&id=1cdaa1ac&scoped=true&"
import script from "./ClassesAdd.vue?vue&type=script&lang=js&"
export * from "./ClassesAdd.vue?vue&type=script&lang=js&"
import style0 from "./ClassesAdd.vue?vue&type=style&index=0&id=1cdaa1ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdaa1ac",
  null
  
)

export default component.exports